import { methods } from "../../utils/axios";

export default class ClientAPI {
  static getClientsList() {
    return methods.get('/clients');
  }

  static clientsList(data) {
    return methods.post('/clients/paginate', data);
  }

  static createClient(data) {
    return methods.post('/clients', data);
  }

  static editClient(id, data) {
    return methods.put(`/clients/${id}`, data)
  }

  static findClient(id) {
    return methods.get(`/clients/${id}`)
  }

  static getClientUsers(id) {
    return methods.get(`/clients/${id}/users`)
  }
}